import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["action", "avatar", "children", "className", "hasStatusLight", "icon", "id", "isDisabled", "isGhost", "isSelected", "mode", "onClick", "removeHandler", "role", "size", "status", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
import { Styled } from './Chip.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var chipIconSizes = {
  small: 12,
  medium: 14,
  large: 16
};
var actionIconSizes = {
  small: 10,
  medium: 12,
  large: 14
};
var Chip = forwardRef(function (_ref, ref) {
  var _cx, _action$icon;

  var action = _ref.action,
      avatar = _ref.avatar,
      children = _ref.children,
      customClassName = _ref.className,
      hasStatusLight = _ref.hasStatusLight,
      icon = _ref.icon,
      id = _ref.id,
      isDisabled = _ref.isDisabled,
      isGhost = _ref.isGhost,
      isSelected = _ref.isSelected,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      onClick = _ref.onClick,
      removeHandler = _ref.removeHandler,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'listitem' : _ref$role,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'default' : _ref$status,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'basic' : _ref$variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasIcon = variant !== 'status' && !avatar && icon;
  var hasAvatar = variant !== 'status' && avatar;
  var hasAction = action || removeHandler ? true : false;
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-chip"), true), _defineProperty(_cx, "".concat(prefix, "-chip--is-").concat(variant), variant), _defineProperty(_cx, "".concat(prefix, "-chip--has-status-light"), hasStatusLight), _defineProperty(_cx, "".concat(prefix, "-chip--has-icon"), hasIcon), _defineProperty(_cx, "".concat(prefix, "-chip--has-avatar"), hasAvatar), _defineProperty(_cx, "".concat(prefix, "-chip--has-action-button"), hasAction), _defineProperty(_cx, "".concat(prefix, "-chip--is-clickable"), onClick), _defineProperty(_cx, "".concat(prefix, "-chip--is-selected"), isSelected), _defineProperty(_cx, "".concat(prefix, "-chip--is-ghost"), isGhost), _defineProperty(_cx, "".concat(prefix, "-chip--is-disabled"), isDisabled), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size,
      status: status
    },
    children: _jsxs(Styled.Chip, _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      className: className,
      "aria-disabled": isDisabled,
      hasAction: hasAction,
      onClick: onClick,
      role: role,
      status: variant === 'status' ? status : 'default',
      tabindex: "-1"
    }, rest), {}, {
      children: [hasIcon && _jsx(Styled.ChipIcon, {
        children: _jsx(Icon, {
          icon: icon,
          size: chipIconSizes[size] || size
        })
      }), hasAvatar && _jsx(Styled.ChipAvatar, {
        size: size,
        src: avatar === null || avatar === void 0 ? void 0 : avatar.src,
        name: avatar === null || avatar === void 0 ? void 0 : avatar.name
      }), hasStatusLight && _jsx(Styled.ChipStatusLight, {
        status: status
      }), _jsx(Styled.ChipLabel, {
        children: children
      }), hasAction && _jsx(Styled.ChipAction, {
        onClick: function onClick(e) {
          e.stopPropagation();
          removeHandler && removeHandler();
          (action === null || action === void 0 ? void 0 : action.onClick) && action.onClick();
        },
        role: "button",
        size: size,
        status: status,
        children: _jsx(Icon, {
          icon: (_action$icon = action === null || action === void 0 ? void 0 : action.icon) !== null && _action$icon !== void 0 ? _action$icon : 'cross',
          size: actionIconSizes[size] || size,
          color: 'var(--dentsu-color-b550)'
        })
      })]
    }))
  });
});
export default Chip;